// frontend/src/searchquery/search.js

import httprequest from './../axios';

/**
 * Get advanced filter options
 */
export const getAdvancedFilterOptions = async () => {
  try {
    const response = await httprequest.get('/searchquery/advanced-filters');
    return response.data;
  } catch (error) {
    console.error('Error getting filter options:', error);
    return null;
  }
};

/**
 * Advanced personalized search
 */
export const advancedPersonalizedSearchOLD = async (searchParams, page = 1, limit = 100, sortBy = 'relevance') => {
  try {
    const response = await httprequest.post('/searchquery/advanced-search', {
      ...searchParams,
      page,
      limit,
      sortBy
    });
    return response.data;
  } catch (error) {
    console.error('Error in advanced search:', error);
    return { games: [], total: 0, page: 1, totalPages: 0 };
  }
};

export const advancedPersonalizedSearch = async (searchParams, page = 1, limit = 5, sortBy = 'relevance', refreshSeed = null) => {
  try {
    const requestBody = {
      ...searchParams,
      page,
      limit,
      sortBy
    };
    
    // Add refresh seed for refresh functionality
    if (refreshSeed !== null) {
      requestBody.refreshSeed = refreshSeed;
    }
    
    const response = await httprequest.post('/searchquery/advanced-search', requestBody);
    return response.data;
  } catch (error) {
    console.error('Error in advanced search:', error);
    return { games: [], total: 0, page: 1, totalPages: 0 };
  }
};

/**
 * Get personalized recommendations (100+ games)
 */
export const getPersonalizedRecommendationsV2 = async (limit = 100, offset = 0, minRelevanceScore = 0, category = 'all') => {
  try {
    const response = await httprequest.get('/searchquery/personalized-recommendations-v2', {
      params: { limit, offset, minRelevanceScore, category }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting personalized recommendations:', error);
    return { recommendations: [], total: 0, hasMore: false };
  }
};

/**
 * Submit thumbs up / down feedback on the whole current result set.
 * Logged-in users only. On thumbs down the backend gradually lowers the
 * weighting of the shown genres/platforms/tags so future results improve.
 *
 * @param {'up'|'down'} feedback
 * @param {{ filters?: object, gameIds?: Array, context?: string }} payload
 */
export const submitRecommendationFeedback = async (feedback, payload = {}) => {
  try {
    const response = await httprequest.post('/searchquery/recommendation-feedback', {
      feedback,
      filters: payload.filters || {},
      gameIds: payload.gameIds || [],
      context: payload.context || 'homepage',
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting recommendation feedback:', error);
    return { success: false };
  }
};

/**
 * Get weighted score recommendations based on a game
 */
export const getWeightedScoreRecommendations = async (gameId, limit = 50) => {
  try {
    const response = await httprequest.get('/searchquery/weighted-recommendations', {
      params: { gameId, limit }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting weighted recommendations:', error);
    return { recommendations: [] };
  }
};